import { ReactNode, createContext, useContext, useState } from 'react';

interface PageTitleContextValue {
  dynamicPart: string;
  setDynamicPart: (value: string) => void;
  overrideTitle: string;
  setOverrideTitle: (value: string) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | undefined>(undefined);

export const PageTitleContextProvider = ({ children }: { children: ReactNode }) => {
  const [dynamicPart, setDynamicPart] = useState('');
  const [overrideTitle, setOverrideTitle] = useState('');

  return (
    <PageTitleContext.Provider
      value={{ dynamicPart, setDynamicPart, overrideTitle, setOverrideTitle }}
    >
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitleContext = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error('usePageTitleContext must be used within PageTitleContextProvider');
  }
  return context;
};
